import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// import { ToastrService } from 'ngx-toastr';
import { PreferencesService } from 'src/app/services/preferences.service';

@Component({
  selector: 'app-alcohol-add',
  templateUrl: './alcohol-add.component.html',
  styleUrls: ['./alcohol-add.component.css']
})
export class AlcoholAddComponent implements OnInit {
  alcoholConsumptionForm!:FormGroup;
  submitted : any = false;
  token: any;
  constructor(public router: Router,
    private prefrencesService: PreferencesService,
    private toastr : ToastrService,
    private activateroute: ActivatedRoute,
    private formBuilder : FormBuilder) { }

  ngOnInit(): void {
    this.alcoholConsumptionForm = this.formBuilder.group({
      name: ['',[Validators.required,this.prefrencesService.noSpacesValidator]],
      image:['',[Validators.required]]
    });

  }

  get addForm() {return this.alcoholConsumptionForm.controls}

  image:any
  onImageSelected(event: any) {
    this.image = event.target.files[0];  
}
  
  onSubmit(){
    this.submitted = true;
    if (this.alcoholConsumptionForm.invalid) {
      return;
    }
    this.token = localStorage['token'];
   let formData = new FormData()
   formData.append('name',this.alcoholConsumptionForm.get('name')?.value)
   formData.append('image', this.image)
    this.prefrencesService.addAlcoholConsumption(formData,this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.alcoholConsumptionForm.reset();
        this.toastr.success(res.message)
        this.router.navigate(['/alcohol-consumption']);
        this.submitted = false;
      }
    });
  }
}
